import React, {Component} from 'react'
import BulkActions from "./actions/BulkActions"
import PropTypes from "prop-types"

class TableHead extends Component {
    _handleChangeChecked = (e) => {
        const {checked} = e.target
        const {onCheckALl} = this.props

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    render() {
        const {selectAll, arrSelected, clearSelected} = this.props

        return (
            <thead className="TableHead">

            {
                arrSelected.length > 0 ?
                    <BulkActions selectAll={selectAll} arrSelected={arrSelected} clearSelected={clearSelected}
                                 onChange={this._handleChangeChecked}/>
                    :
                    <tr>
                        <th className="SelectedCheckbox"><input type='checkbox' checked={selectAll} onChange={this._handleChangeChecked}/></th>
                        <th className="OrderNumber">Order Number</th>
                        <th className="Reason">Lý do</th>
                        <th className="Label">Label</th>
                        <th className="WeightNet">Cân nặng theo thực tế</th>
                        <th className="WeightSetting">Cân nặng theo setting</th>
                        <th className="Status">Trạng thái</th>
                        <th className="Date">
                            Ngày
                            <div className="font-weight-normal font-size-sm">
                                <span className="badge badge-mark border-success mr-1"/>
                                Yêu cầu
                            </div>
                            <div className="font-weight-normal font-size-sm">
                                <span className="badge badge-mark border-primary mr-1"/>
                                Generate lại
                            </div>
                        </th>
                        <th className="Message">Thông báo</th>
                        <th className="Note">Ghi chú</th>
                        <th className="Change">Thay đổi hạn mức cân nặng?</th>
                        <th className="Actions">Hành động</th>
                    </tr>}
            </thead>
        )
    }
}

TableHead.propTypes = {
    selectAll: PropTypes.bool,
    arrSelected: PropTypes.array,
    clearSelected: PropTypes.func.isRequired
}

export default TableHead